module.exports = __webpack_public_path__ + "img/bgAr.7709873f.png";